import TariffBar from "../tariff.bar";
import { useNavigate } from 'react-router-dom';
import { AddTransaction, Transaction } from "../transaction";
import useGlobal from "../../../store";

const Orders = ({ reloadDummy }) => {

  const [ globalState, globalActions ] = useGlobal();

  const { 

    orders,
    user_tariff, 
    tariff_comission, 
    deal_price_watch_mode

  } = globalState;
  
  const { deals } = globalActions;

  const navigate = useNavigate();

  function kickIfHaveNoSubscribe() { 
    
    if ( !user_tariff?.active ) { navigate('/tariff'); return false; } 
    else return true;
  
  }

  return (

    <div className = "orders-contanter">

      { user_tariff?.active && <TariffBar data = { user_tariff } /> }

      { orders.length > 0 && orders.map( ( el, key ) => (

        <Transaction

          key = { key }
          id = { el.id }
          name = { el.name }
          type = { el.type }
          result = { el.result }
          movements = { el.movements }
          amount = { el.amount || "" }
          initialComment = { el.comment || "" }
          saveComment = { cmnt => { kickIfHaveNoSubscribe() && deals.comment( el.id, cmnt ) }}
          setMaxAmount = { amnt => deals.setMaxAmount( el.id, amnt ) }
          date_create = { el.date_create }
          date_update = { el.date_update }
          tariff_comission = { tariff_comission }
          price_watch_mode = { deal_price_watch_mode }
          actionBuy   = { async ( obj, updateState = true ) => { if ( kickIfHaveNoSubscribe() ) return await deals.movement.add( obj, reloadDummy, updateState ) }}
          actionSell  = { async ( obj, updateState = true ) => { if ( kickIfHaveNoSubscribe() ) return await deals.movement.add( obj, reloadDummy, updateState ) }}
          actionClose = { async ( saveToHistory, closeCard, transaction ) => { if ( kickIfHaveNoSubscribe() ) return await deals.close( saveToHistory, closeCard, transaction, reloadDummy ) } }
          actionRemoveMovement = {  async ( obj ) => { if ( kickIfHaveNoSubscribe() ) return await deals.movement.remove( obj, reloadDummy ) } }
          actionRemoveMovements = { async ( obj ) => { if ( kickIfHaveNoSubscribe() ) return await deals.movement.removeAll( obj, reloadDummy ) } }
          
        />

      ))}

      <AddTransaction
      
        action = { ( ticker ) => { kickIfHaveNoSubscribe() && deals.create( ticker, reloadDummy ) } }
        centerred = { orders.length === 0 }
        
      />
      
    </div>      

  );

}

export default Orders;